/* global window */
const canUseDOM = !!(typeof window !== 'undefined' && window?.document?.createElement);

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
const supportsHistory = () => {
  /* istanbul ignore next */
  if (!canUseDOM) {
    return false;
  }

  const ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1)
    && ua.indexOf('Mobile Safari') !== -1
    && ua.indexOf('Chrome') === -1
    && ua.indexOf('Windows Phone') === -1
  ) {
    return false;
  }
  return window.history && 'pushState' in window.history;
};

const getLocationForHash = (hash) => (typeof window !== 'undefined'
  ? `${window.location.origin}${window.location.pathname}${window.location.search}#${hash}`
  : null);

/* istanbul ignore next */
const supportsWebShareApi = () => typeof window !== 'undefined' && window.navigator && window.navigator.share;

/* istanbul ignore next */
const forEach = (array, callback, scope) => {
  for (let i = 0; i < array.length; i += 1) {
    // eslint-disable-next-line security/detect-object-injection
    callback.call(scope, array[i]);
  }
};

module.exports = {
  canUseDOM,
  supportsHistory,
  getLocationForHash,
  supportsWebShareApi,
  forEach,
};
